/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleUpdate } from '../../models/role-update';
import { UserRole } from '../../models/user-role';

export interface TenantsTenantIdRolesRoleNamePut$Params {
  'Active-Tenant-Identifier': string;

/**
 * tenant identifier
 */
  tenantId: string;

/**
 * role name to update
 */
  roleName: string;
      body: RoleUpdate
}

export function tenantsTenantIdRolesRoleNamePut(http: HttpClient, rootUrl: string, params: TenantsTenantIdRolesRoleNamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRole>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdRolesRoleNamePut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('tenantId', params.tenantId, {});
    rb.path('roleName', params.roleName, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRole>;
    })
  );
}

tenantsTenantIdRolesRoleNamePut.PATH = '/tenants/{tenantId}/roles/{roleName}';
